import React from '@root/vendor/react';

const RootBonusContext = React.createContext();

export default RootBonusContext;
